import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Chip,
} from '@mui/material';
import { useStateValue } from '../../../contexto/store';
import { withRouter } from 'react-router-dom';
import {
  actualizarCliente,
  obtenerTelefonosCliente,
  obtenerDireccionesCliente,
  deleteTelefono,
  deleteDireccion,
  obtenerBarrios,
  obtenerCiudades, obtenerTipoCliente,
  ObtenerTareasRelacionadasAlCliente,
  deleteRed,
  obtenerRedesCliente,
} from '../../../actions/ClientesAction';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { produce } from 'immer';
import { generate } from 'shortid';
import moment from 'moment';
import { Autocomplete } from '@mui/material';
import { obtenerSugerencias } from '../../../actions/SugerenciasAction';
import { useHistory } from 'react-router-dom';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';
import { obtenerCampanas } from '../../../actions/CampanasAction';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ShareIcon from '@mui/icons-material/Share';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import CampaignIcon from '@mui/icons-material/Campaign';
import BusinessIcon from '@mui/icons-material/Business';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import NotesIcon from '@mui/icons-material/Notes';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BadgeIcon from '@mui/icons-material/Badge';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import VisibilityIcon from '@mui/icons-material/Visibility';
import CategoryIcon from '@mui/icons-material/Category';
// FERNADO COLUCCI
const PerfilCliente = (props) => {
  const [valorSelect, setValorSelect] = useState('');
  const [campana, setCampana] = useState('');
  //###################################
const [tipoCliente, setTipoCliente] = useState('');
const [DataTipoCliente, setDataTipoCliente] = useState([]);
  //###################################

  // const classes = useStyles();
  const [barrioCiu, setBarrioCiu] = useState('');
  const [estadoBotonRedes, setEstadoBotonRedes] = useState(true);
  const [redes, setRedes] = useState([]);
  const [DataCiu, setDataCiu] = useState([]);
  const [DataBa, setDataBa] = useState([]);
  const [listaTareasCliente, setListaTareasCliente] = useState([]);
  const [listaSugerenciasCliente, setListaSugerenciasCliente] = useState([]);
  const [telefonos, setTelefonos] = useState([]);
  const [direcciones, setDirecciones] = useState([]);
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const datosCliente = props.location.state;
  const [cliente, setCliente] = useState({
    apellido: '',
    ci: '',
    ruc: '',
    nombre: '',
    profesionorubro: '',
    hobby: '',
    observaciones: '',
  });
  const [estadoBotonTelefono, setEstadoBotonTelefono] = useState(true);
  const [estadoBotonDirecciones, setEstadoBotonDirecciones] = useState(true);
  const [estadoBotonTareas, setEstadoBotonTareas] = useState(false);
  const [estadoBotonSugerencias, setEstadoBotonSugerencias] = useState(false);
  const [Datatel, setDatatel] = useState([]);
  const [Datadir, setDatadir] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const history = useHistory();
  const [DataRedes, setDataRedes] = useState([]);
  const [Datar, setDatar] = useState([]);
  const eliminarRed = (red) => {
    const id = red.reD_Id;
    deleteRed(id).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Red Social eliminada',
          },
        });
        const id = datosCliente.cliente.clientE_Id;
        obtenerRedesCliente(id).then((response) => {
          const Data = response.data;
          setDataRedes(Data);
        });
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Errores al intentar eliminar ',
          },
        });
      }
    });
  };
  const eliminarTelefono = (telefono) => {
    const id = telefono.telefonO_Id;
    deleteTelefono(id).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Telefono eliminado',
          },
        });
        const id = datosCliente.clientE_Id;
        obtenerTelefonosCliente(id).then((response) => {
          const Data = response.data;
          setDatatel(Data);
        });
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Errores al intentar eliminar ',
          },
        });
      }
    });
  };

  const eliminarDireccion = (direccion) => {
    const id = direccion.direccioN_Id;
    deleteDireccion(id).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Direccion eliminada',
          },
        });
        const id = datosCliente.clientE_Id;
        obtenerDireccionesCliente(id).then((response) => {
          const Data = response.data;
          setDatadir(Data);
        });
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Errores al intentar eliminar ',
          },
        });
      }
    });
  };

  const mostrarTelefonos = () => {
    if (estadoBotonTelefono === false) {
      setEstadoBotonTelefono(true);
    } else {
      setEstadoBotonTelefono(false);
    }
  };

  const mostrarDirecciones = () => {
    if (estadoBotonDirecciones === false) {
      setEstadoBotonDirecciones(true);
    } else {
      setEstadoBotonDirecciones(false);
    }
  };

  const mostrarTareas = () => {
    if (estadoBotonTareas === false) {
      setEstadoBotonTareas(true);
    } else {
      setEstadoBotonTareas(false);
    }
  };
  const mostrarSugerencias = () => {
    if (estadoBotonSugerencias === false) {
      setEstadoBotonSugerencias(true);
    } else {
      setEstadoBotonSugerencias(false);
    }
  };

  const mostrarRedes = () => {
    if (estadoBotonRedes === false) {
      setEstadoBotonRedes(true);
    } else {
      setEstadoBotonRedes(false);
    }
  };
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setCliente((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const selectCampanahandleChange = (event) => {
    setValorSelect(event.target.value);
    setCampana(event.target.value);
  };

  const ActualizarCliente = (e) => {
    e.preventDefault();
    const id = datosCliente.clientE_Id;
    let objetoClienteModificado = {};
    if (
      telefonos[0] === undefined &&
      direcciones[0] === undefined &&
      redes[0] === undefined
    ) {
      objetoClienteModificado = {
        NOMBRE: cliente.nombre,
        APELLIDO: cliente.apellido,
        CI: cliente.ci,
        RUC: cliente.ruc,
        PROFESIONORUBRO: cliente.profesionorubro,
        HOBBY: cliente.hobby,
        FECHULTMOD: moment().format(),
        OBSERVACIONES: cliente.observaciones,
      };
    } else if (
      telefonos[0] !== undefined &&
      direcciones[0] === undefined &&
      redes[0] === undefined
    ) {
      if (
        telefonos[0].DESCRITELEFONO !== '' ||
        telefonos[0].DETALLESTELEFONO !== ''
      ) {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          TELEFONOS: telefonos,
          OBSERVACIONES: cliente.observaciones,
        };
      } else {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          OBSERVACIONES: cliente.observaciones,
        };
      }
    } else if (
      telefonos[0] === undefined &&
      direcciones[0] !== undefined &&
      redes[0] === undefined
    ) {
      if (
        direcciones[0].DESCRIDIRECCION !== '' ||
        direcciones[0].DETALLESDIRECCION !== ''
      ) {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          DIRECCIONES: direcciones,
          OBSERVACIONES: cliente.observaciones,
        };
      } else {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          OBSERVACIONES: cliente.observaciones,
        };
      }
    } else if (
      telefonos[0] === undefined &&
      direcciones[0] !== undefined &&
      redes[0] !== undefined
    ) {
      if (
        (direcciones[0].DESCRIDIRECCION !== '' ||
          direcciones[0].DETALLESDIRECCION !== '') &&
        (redes[0].Nick === '' || redes[0].RedSocial === '')
      ) {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          DIRECCIONES: direcciones,
          OBSERVACIONES: cliente.observaciones,
        };
      } else if (
        (redes[0].Nick !== '' || redes[0].RedSocial !== '') &&
        (direcciones[0].DESCRIDIRECCION === '' ||
          direcciones[0].DETALLESDIRECCION === '')
      ) {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFECIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          REDES: redes,
          OBSERVACIONES: cliente.observaciones,
        };
      } else {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          DIRECCIONES: direcciones,
          REDES: redes,
          OBSERVACIONES: cliente.observaciones,
        };
      }
    } else if (
      telefonos[0] !== undefined &&
      direcciones[0] === undefined &&
      redes[0] !== undefined
    ) {
      if (
        (telefonos[0].DESCRITELEFONO !== '' ||
          telefonos[0].DETALLESTELEFONO !== '') &&
        (redes[0].Nick === '' || redes[0].RedSocial === '')
      ) {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          TELEFONOS: telefonos,
          OBSERVACIONES: cliente.observaciones,
        };
      } else if (
        (redes[0].Nick !== '' || redes[0].RedSocial !== '') &&
        (telefonos[0].DESCRITELEFONO === '' ||
          telefonos[0].DETALLESTELEFONO === '')
      ) {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          REDES: redes,
          OBSERVACIONES: cliente.observaciones,
        };
      } else {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          TELEFONOS: telefonos,
          REDES: redes,
          OBSERVACIONES: cliente.observaciones,
        };
      }
    } else if (
      telefonos[0] !== undefined &&
      direcciones[0] !== undefined &&
      redes[0] === undefined
    ) {
      if (
        (telefonos[0].DESCRITELEFONO !== '' ||
          telefonos[0].DETALLESTELEFONO !== '') &&
        (direcciones[0].DESCRIDIRECCION === '' ||
          direcciones[0].DETALLESDIRECCION === '')
      ) {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          TELEFONOS: telefonos,
          OBSERVACIONES: cliente.observaciones,
        };
      } else if (
        (direcciones[0].DESCRIDIRECCION !== '' ||
          direcciones[0].DETALLESDIRECCION !== '') &&
        (telefonos[0].DESCRITELEFONO === '' ||
          telefonos[0].DETALLESTELEFONO === '')
      ) {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          DIRECCIONES: direcciones,
          OBSERVACIONES: cliente.observaciones,
        };
      } else {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          TELEFONOS: telefonos,
          DIRECCIONES: direcciones,
          OBSERVACIONES: cliente.observaciones,
        };
      }
    } else if (
      telefonos[0] === undefined &&
      direcciones[0] === undefined &&
      redes[0] !== undefined
    ) {
      if (redes[0].Nick !== '' || redes[0].RedSocial !== '') {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          REDES: redes,
          OBSERVACIONES: cliente.observaciones,
        };
      } else {
        objetoClienteModificado = {
          NOMBRE: cliente.nombre,
          APELLIDO: cliente.apellido,
          CI: cliente.ci,
          RUC: cliente.ruc,
          PROFESIONORUBRO: cliente.profesionorubro,
          HOBBY: cliente.hobby,
          FECHULTMOD: moment().format(),
          OBSERVACIONES: cliente.observaciones,
        };
      }
    } else {
      objetoClienteModificado = {
        NOMBRE: cliente.nombre,
        APELLIDO: cliente.apellido,
        CI: cliente.ci,
        RUC: cliente.ruc,
        PROFESIONORUBRO: cliente.profesionorubro,
        HOBBY: cliente.hobby,
        FECHULTMOD: moment().format(),
        TELEFONOS: telefonos,
        DIRECCIONES: direcciones,
        REDES: redes,
        OBSERVACIONES: cliente.observaciones,
      };
    }
    if (campana !== '') {
      objetoClienteModificado['CAMPANA_Id'] = campana;
    }
    if (tipoCliente !== '') {
      objetoClienteModificado['CODTIPOCLIENTE'] = tipoCliente;
    }
    actualizarCliente(id, objetoClienteModificado).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se guardo exitosamente el Cliente',
          },
        });
        const id = datosCliente.clientE_Id;
        obtenerTelefonosCliente(id).then((response) => {
          const Data = response.data;
          setDatatel(Data);
        });
        obtenerDireccionesCliente(id).then((response) => {
          const Data = response.data;
          setDatadir(Data);
        });
        setTelefonos([]);
        setDirecciones([]);
        let objetoAudi = {
          usuario: sesionUsuario.usuario.nombrecompleto,
          accion: 'Modificacion',
          panel: 'Gestion de Clientes',
          tabla: 'CLIENTES',
          filaafectada: props.location.state.clientE_Id,
          UsuarioId: sesionUsuario.usuario.id,
        };
        RegistrarAccion(objetoAudi);
        props.history.goBack();
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Errores al intentar guardar ',
          },
        });
      }
    });
  };
  const cerrarClientesPerfil = () => {
    setCliente({
      apellido: '',
      ci: '',
      ruc: '',
      nombre: '',
    });
    props.history.goBack();
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const mostrarPerfilTarea = (tarea) => {
    tarea['TipoVisitante'] ="Visitante";
    tarea['cliente'] = {
    clientE_Id: datosCliente.clientE_Id,
    nombre: datosCliente.nombre,
    apellido: datosCliente.apellido,
  };
  tarea['tipotarea'] = {
    descritipotarea: tarea.descritipotarea ?? '',
  };
  tarea['presupuesto'] = null;
  tarea['posiblecliente'] = null;
  tarea['motivocancelacion'] = tarea.motivocancelacion ?? null;
  tarea['completado'] = tarea.completado ?? null;
  console.log("Tarea a mostrar en perfil:", tarea);
    history.push({ pathname: '/perfilTarea', state: tarea });
  };
  useEffect(() => {
    const id = datosCliente.clientE_Id;
    if (id !== undefined) {
      obtenerRedesCliente(id).then((response) => {
        const Data = response.data;
        setDataRedes(Data);
      });
      obtenerTelefonosCliente(id).then((response) => {
        const Data = response.data;
        setDatatel(Data);
      });
      obtenerDireccionesCliente(id).then((response) => {
        const Data = response.data;
        setDatadir(Data);
      });
      ObtenerTareasRelacionadasAlCliente(id).then((response) => {
          console.log('TAREAS RESPONSE:', response.data);
        setListaTareasCliente(response.data);
      });
      obtenerSugerencias(id).then((response) => {
        setListaSugerenciasCliente(response.data);
      });
    }
    if (
      datosCliente.nombre !== '' ||
      datosCliente.apellido !== '' ||
      datosCliente.ci !== '' ||
      datosCliente.ruc !== ''
    ) {
      if (props.location.state.campana !== null) {
        setValorSelect(props.location.state.campana.campanA_Id);
      }
      setCliente({
        nombre: datosCliente.nombre,
        apellido: datosCliente.apellido,
        ci: datosCliente.ci,
        ruc: datosCliente.ruc,
        profesionorubro: datosCliente.profesionorubro,
        hobby: datosCliente.hobby,
        observaciones: datosCliente.observaciones,
      });
    } else if (
      datosCliente.nombre === '' &&
      datosCliente.apellido === '' &&
      datosCliente.ci === '' &&
      datosCliente.ruc === ''
    ) {
      props.history.push('/clientesPrincipal');
    }
    obtenerCiudades().then((response) => {
      const Data = response.data;
      setDataCiu(Data);
    });
     obtenerTipoCliente().then((response) => {
      const Data = response.data;
      setDataTipoCliente(Data);
    });
    if (barrioCiu !== '') {
      obtenerBarrios(barrioCiu).then((response) => {
        const Data = response.data;
        setDataBa(Data);
      });
    }
    obtenerCampanas().then((response) => {
      console.log('Campañas obtenidas:', response);
      const Data = response.data;
      setDatar(Data);
    });
    // Establecer tipo de cliente si existe
    if (props.location.state.tipoCliente && props.location.state.tipoCliente.codtipocliente  ) {
      setTipoCliente(props.location.state.tipoCliente.codtipocliente  );
    }
    
  }, [sesionUsuario, props, datosCliente, barrioCiu]);
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Header con Gradient */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          mb: 3,
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          color: 'white',
          borderRadius: 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'rgba(255, 255, 255, 0.2)',
              backdropFilter: 'blur(10px)',
            }}
          >
            <PersonIcon sx={{ fontSize: 32 }} />
          </Box>
          <Box>
            <Typography variant="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
              Perfil del Cliente
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              Editar información y datos de contacto
            </Typography>
          </Box>
        </Box>
      </Paper>

      {/* Formulario de Información Básica */}
      <Paper elevation={0} sx={{ p: 3, mb: 3, border: '1px solid #e0e0e0' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
          <BadgeIcon sx={{ color: '#1976d2' }} />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Información Básica
          </Typography>
        </Box>
        
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <TextField
              name="nombre"
              value={cliente.nombre}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              label="Nombre"
              InputProps={{
                startAdornment: <PersonIcon sx={{ mr: 1, color: 'action.active' }} />,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="apellido"
              value={cliente.apellido}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              label="Apellido/Razón Social"
              InputProps={{
                startAdornment: <BusinessIcon sx={{ mr: 1, color: 'action.active' }} />,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="ci"
              value={cliente.ci}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              label="Nro. de Cédula"
              InputProps={{
                startAdornment: <BadgeIcon sx={{ mr: 1, color: 'action.active' }} />,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="ruc"
              value={cliente.ruc}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              label="RUC"
              InputProps={{
                startAdornment: <BusinessIcon sx={{ mr: 1, color: 'action.active' }} />,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              multiline
              rows={2}
              name="profesionorubro"
              value={cliente.profesionorubro}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Profesión/Rubro"
              InputProps={{
                startAdornment: <SportsEsportsIcon sx={{ mr: 1, color: 'action.active', alignSelf: 'flex-start', mt: 1 }} />,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              multiline
              rows={2}
              name="hobby"
              value={cliente.hobby}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Hobby"
              InputProps={{
                startAdornment: <SportsEsportsIcon sx={{ mr: 1, color: 'action.active', alignSelf: 'flex-start', mt: 1 }} />,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              name="tipoCliente"
              value={
                DataTipoCliente.length > 0 
                  ? DataTipoCliente.find(tipo => tipo.codtipocliente === props.location.state.codtipocliente)?.destipocliente || 'No asignado'
                  : 'Cargando...'
              }
              variant="outlined"
              fullWidth
              label="Tipo de Cliente"
              InputProps={{
                readOnly: true,
                startAdornment: <CategoryIcon sx={{ mr: 1, color: 'action.active' }} />,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel>Campaña</InputLabel>
              <Select
                value={valorSelect}
                onChange={selectCampanahandleChange}
                label="Campaña"
                startAdornment={<CampaignIcon sx={{ ml: 1, mr: 1, color: 'action.active' }} />}
              >
                {Datar.map((campana) => (
                  <MenuItem key={campana.campanA_Id} value={campana.campanA_Id}>
                    {campana.descricampana}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              multiline
              rows={4}
              name="observaciones"
              value={cliente.observaciones}
              onChange={ingresarValoresMemoria}
              variant="outlined"
              fullWidth
              label="Observaciones"
              InputProps={{
                startAdornment: <NotesIcon sx={{ mr: 1, color: 'action.active', alignSelf: 'flex-start', mt: 1 }} />,
              }}
            />
          </Grid>
        </Grid>
      </Paper>

      {/* Accordion de Teléfonos */}
      <Accordion 
        expanded={!estadoBotonTelefono}
        onChange={mostrarTelefonos}
        sx={{ mb: 2, border: '1px solid #e0e0e0', '&:before': { display: 'none' } }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
            <PhoneIcon sx={{ color: '#1976d2' }} />
            <Typography variant="h6" sx={{ fontWeight: 600, flexGrow: 1 }}>
              Teléfonos
            </Typography>
            <Chip 
              label={`${Datatel.length} registrados`} 
              size="small" 
              sx={{ bgcolor: '#1976d2', color: 'white' }}
            />
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setTelefonos((telefonoActual) => [
                  ...telefonoActual,
                  {
                    CODTELEFONO: generate(),
                    DESCRITELEFONO: '',
                    DETALLESTELEFONO: '',
                  },
                ]);
              }}
              sx={{ 
                bgcolor: '#1976d2', 
                color: 'white',
                '&:hover': { bgcolor: '#1976d2' }
              }}
            >
              <AddCircleOutlineIcon fontSize="small" />
            </IconButton>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {/* Tabla de Teléfonos Existentes */}
          {Datatel.length > 0 ? (
            <TableContainer sx={{ mb: 3 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: 'rgba(102, 126, 234, 0.1)' }}>
                    <TableCell sx={{ fontWeight: 600 }}>Teléfono</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Detalles</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Prioridad</TableCell>
                    <TableCell sx={{ fontWeight: 600 }} align="center">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Datatel.map((telefono) => (
                    <TableRow 
                      key={telefono.telefonO_Id}
                      sx={{ '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.02)' } }}
                    >
                      <TableCell>{telefono.descritelefono}</TableCell>
                      <TableCell>{telefono.detallestelefono}</TableCell>
                      <TableCell>{telefono.prioridad}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => eliminarTelefono(telefono)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 3, color: 'text.secondary' }}>
              <PhoneIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
              <Typography>No hay teléfonos registrados</Typography>
            </Box>
          )}

          {/* Nuevos Teléfonos */}
          {telefonos.length > 0 && (
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 2, color: '#1976d2', fontWeight: 600 }}>
                Nuevos Teléfonos a Agregar:
              </Typography>
              {telefonos.map((t, index) => (
                <Paper
                  key={t.CODTELEFONO}
                  variant="outlined"
                  sx={{ p: 2, mb: 2, borderRadius: 2 }}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={5}>
                      <TextField
                        name="TELEFONO"
                        value={t.DESCRITELEFONO}
                        onChange={(e) => {
                          const DESCRITELEFONO = e.target.value;
                          setTelefonos((telefonoActual) =>
                            produce(telefonoActual, (v) => {
                              v[index].DESCRITELEFONO = DESCRITELEFONO;
                            })
                          );
                        }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Nro. Teléfono"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="DETALLESTELEFONO"
                        value={t.DETALLESTELEFONO}
                        onChange={(e) => {
                          const DETALLESTELEFONO = e.target.value;
                          setTelefonos((telefonoActual) =>
                            produce(telefonoActual, (v) => {
                              v[index].DETALLESTELEFONO = DETALLESTELEFONO;
                            })
                          );
                        }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Detalles"
                      />
                    </Grid>
                    <Grid item xs={12} sm={1}>
                      <IconButton
                        color="error"
                        onClick={() => {
                          setTelefonos((telefonoActual) =>
                            telefonoActual.filter((x) => x.CODTELEFONO !== t.CODTELEFONO)
                          );
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Paper>
              ))}
            </Box>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Accordion de Direcciones */}
      <Accordion 
        expanded={!estadoBotonDirecciones}
        onChange={mostrarDirecciones}
        sx={{ mb: 2, border: '1px solid #e0e0e0', '&:before': { display: 'none' } }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
            <LocationOnIcon sx={{ color: '#1976d2' }} />
            <Typography variant="h6" sx={{ fontWeight: 600, flexGrow: 1 }}>
              Direcciones
            </Typography>
            <Chip 
              label={`${Datadir.length} registradas`} 
              size="small" 
              sx={{ bgcolor: '#1976d2', color: 'white' }}
            />
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setDirecciones((direccionActual) => [
                  ...direccionActual,
                  {
                    CODDIRECCION: generate(),
                    DETALLESDIRECCION: '',
                    DESCRIDIRECCION: '',
                    CIUDAD: { CIUDAD_Id: '' },
                    BARRIO: { BARRIO_Id: '' },
                  },
                ]);
              }}
              sx={{ 
                bgcolor: '#1976d2', 
                color: 'white',
                '&:hover': { bgcolor: '#1976d2' }
              }}
            >
              <AddCircleOutlineIcon fontSize="small" />
            </IconButton>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {/* Tabla de Direcciones Existentes */}
          {Datadir.length > 0 ? (
            <TableContainer sx={{ mb: 3 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: 'rgba(102, 126, 234, 0.1)' }}>
                    <TableCell sx={{ fontWeight: 600 }}>Dirección</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Detalles</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Barrio</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Ciudad</TableCell>
                    <TableCell sx={{ fontWeight: 600 }} align="center">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Datadir.map((direccion) => (
                    <TableRow 
                      key={direccion.direccioN_Id}
                      sx={{ '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.02)' } }}
                    >
                      <TableCell>{direccion.descridireccion}</TableCell>
                      <TableCell>{direccion.detallesdireccion}</TableCell>
                      <TableCell>{direccion.barrio.describarrio}</TableCell>
                      <TableCell>{direccion.ciudad.descriciudad}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => eliminarDireccion(direccion)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 3, color: 'text.secondary' }}>
              <LocationOnIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
              <Typography>No hay direcciones registradas</Typography>
            </Box>
          )}

          {/* Nuevas Direcciones */}
          {direcciones.length > 0 && (
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 2, color: '#1976d2', fontWeight: 600 }}>
                Nuevas Direcciones a Agregar:
              </Typography>
              {direcciones.map((d, index) => (
                <Paper
                  key={d.CODDIRECCION}
                  variant="outlined"
                  sx={{ p: 3, mb: 2, borderRadius: 2, position: 'relative' }}
                >
                  <Chip 
                    label={`Dirección ${index + 1}`} 
                    size="small" 
                    sx={{ position: 'absolute', top: 16, right: 56, bgcolor: '#1976d2', color: 'white' }}
                  />
                  <IconButton
                    color="error"
                    onClick={() => {
                      setDirecciones((direccionActual) =>
                        direccionActual.filter((x) => x.CODDIRECCION !== d.CODDIRECCION)
                      );
                    }}
                    sx={{ position: 'absolute', top: 12, right: 12 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                  
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        multiline
                        rows={2}
                        name="DIRECCION"
                        value={d.DESCRIDIRECCION}
                        onChange={(e) => {
                          const DESCRIDIRECCION = e.target.value;
                          setDirecciones((direccionActual) =>
                            produce(direccionActual, (v) => {
                              v[index].DESCRIDIRECCION = DESCRIDIRECCION;
                            })
                          );
                        }}
                        variant="outlined"
                        fullWidth
                        label="Dirección"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        multiline
                        rows={2}
                        name="DETALLESDIRECCION"
                        value={d.DETALLESDIRECCION}
                        onChange={(e) => {
                          const DETALLESDIRECCION = e.target.value;
                          setDirecciones((direccionActual) =>
                            produce(direccionActual, (v) => {
                              v[index].DETALLESDIRECCION = DETALLESDIRECCION;
                            })
                          );
                        }}
                        variant="outlined"
                        fullWidth
                        label="Detalles"
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        options={DataCiu}
                        getOptionLabel={(option) => option.descriciudad || ''}
                        renderInput={(params) => (
                          <TextField {...params} label="Buscar Ciudades" variant="outlined" />
                        )}
                        onChange={(e, value) => {
                          if (value) {
                            setDirecciones((direccionActual) =>
                              produce(direccionActual, (v) => {
                                v[index].CIUDAD.CIUDAD_Id = value.ciudaD_Id;
                              })
                            );
                            setBarrioCiu(value.ciudaD_Id);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Autocomplete
                        options={DataBa}
                        getOptionLabel={(option) => option.describarrio || ''}
                        renderInput={(params) => (
                          <TextField {...params} label="Buscar Barrios" variant="outlined" />
                        )}
                        onChange={(e, value) => {
                          if (value) {
                            setDirecciones((direccionActual) =>
                              produce(direccionActual, (v) => {
                                v[index].BARRIO.BARRIO_Id = value.barriO_Id;
                              })
                            );
                          }
                        }}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              ))}
            </Box>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Accordion de Redes Sociales */}
      <Accordion 
        expanded={!estadoBotonRedes}
        onChange={mostrarRedes}
        sx={{ mb: 2, border: '1px solid #e0e0e0', '&:before': { display: 'none' } }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
            <ShareIcon sx={{ color: '#1976d2' }} />
            <Typography variant="h6" sx={{ fontWeight: 600, flexGrow: 1 }}>
              Redes Sociales
            </Typography>
            <Chip 
              label={`${DataRedes.length} redes`} 
              size="small" 
              sx={{ bgcolor: '#1976d2', color: 'white' }}
            />
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setRedes((redActual) => [
                  ...redActual,
                  {
                    CODRED: generate(),
                    Nick: '',
                    RedSocial: '',
                  },
                ]);
              }}
              sx={{ 
                bgcolor: '#1976d2', 
                color: 'white',
                '&:hover': { bgcolor: '#1976d2' }
              }}
            >
              <AddCircleOutlineIcon fontSize="small" />
            </IconButton>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {/* Tabla de Redes Existentes */}
          {DataRedes.length > 0 ? (
            <TableContainer sx={{ mb: 3 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ bgcolor: 'rgba(102, 126, 234, 0.1)' }}>
                    <TableCell sx={{ fontWeight: 600 }}>Usuario/Nick</TableCell>
                    <TableCell sx={{ fontWeight: 600 }}>Red Social</TableCell>
                    <TableCell sx={{ fontWeight: 600 }} align="center">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {DataRedes.map((red) => (
                    <TableRow 
                      key={red.reD_Id}
                      sx={{ '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.02)' } }}
                    >
                      <TableCell>{red.nick}</TableCell>
                      <TableCell>{red.redsocial}</TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => eliminarRed(red)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Box sx={{ textAlign: 'center', py: 3, color: 'text.secondary' }}>
              <ShareIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
              <Typography>No hay redes sociales registradas</Typography>
            </Box>
          )}

          {/* Nuevas Redes */}
          {redes.length > 0 && (
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 2, color: '#1976d2', fontWeight: 600 }}>
                Nuevas Redes Sociales a Agregar:
              </Typography>
              {redes.map((t, index) => (
                <Paper
                  key={t.CODRED}
                  variant="outlined"
                  sx={{ p: 2, mb: 2, borderRadius: 2 }}
                >
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={5}>
                      <TextField
                        name="RedSocial"
                        value={t.RedSocial}
                        onChange={(e) => {
                          const RedSocial = e.target.value;
                          setRedes((redActual) =>
                            produce(redActual, (v) => {
                              v[index].RedSocial = RedSocial;
                            })
                          );
                        }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Red Social"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        name="Nick"
                        value={t.Nick}
                        onChange={(e) => {
                          const Nick = e.target.value;
                          setRedes((redActual) =>
                            produce(redActual, (v) => {
                              v[index].Nick = Nick;
                            })
                          );
                        }}
                        variant="outlined"
                        fullWidth
                        size="small"
                        label="Nombre de usuario"
                      />
                    </Grid>
                    <Grid item xs={12} sm={1}>
                      <IconButton
                        color="error"
                        onClick={() => {
                          setRedes((redActual) =>
                            redActual.filter((x) => x.CODRED !== t.CODRED)
                          );
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Paper>
              ))}
            </Box>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Accordion de Tareas */}
      <Accordion 
        expanded={!estadoBotonTareas}
        onChange={mostrarTareas}
        sx={{ mb: 2, border: '1px solid #e0e0e0', '&:before': { display: 'none' } }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <AssignmentIcon sx={{ color: '#1976d2' }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Tareas Relacionadas
            </Typography>
            <Chip 
              label={listaTareasCliente.length} 
              size="small" 
              sx={{ bgcolor: '#1976d2', color: 'white' }}
            />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {listaTareasCliente.length > 0 ? (
            <Paper elevation={0}>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: 'rgba(102, 126, 234, 0.1)' }}>
                      <TableCell sx={{ fontWeight: 600 }}>Fecha Creación</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Asignado a</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Detalles</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Fecha Vto.</TableCell>
                      <TableCell sx={{ fontWeight: 600 }} align="center">Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {listaTareasCliente
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((tarea) => (
                        <TableRow 
                          key={tarea.tareA_Id}
                          sx={{ '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.02)' } }}
                        >
                          <TableCell>{tarea.fechacreacion.substr(-20, 10)}</TableCell>
                          <TableCell>{tarea.usuarioasignado}</TableCell>
                          <TableCell>{tarea.numtarea}</TableCell>
                          <TableCell>{tarea.fechavto.substr(-20, 10)}</TableCell>
                          <TableCell align="center">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => mostrarPerfilTarea(tarea)}
                            >
                              <VisibilityIcon fontSize="small" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={listaTareasCliente.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Filas por página:"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
              />
            </Paper>
          ) : (
            <Box sx={{ textAlign: 'center', py: 3, color: 'text.secondary' }}>
              <AssignmentIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
              <Typography>No hay tareas relacionadas</Typography>
            </Box>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Accordion de Sugerencias */}
      <Accordion 
        expanded={!estadoBotonSugerencias}
        onChange={mostrarSugerencias}
        sx={{ mb: 3, border: '1px solid #e0e0e0', '&:before': { display: 'none' } }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <LightbulbIcon sx={{ color: '#1976d2' }} />
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Sugerencias del Cliente
            </Typography>
            <Chip 
              label={listaSugerenciasCliente.length} 
              size="small" 
              sx={{ bgcolor: '#1976d2', color: 'white' }}
            />
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          {listaSugerenciasCliente.length > 0 ? (
            <Paper elevation={0}>
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ bgcolor: 'rgba(102, 126, 234, 0.1)' }}>
                      <TableCell sx={{ fontWeight: 600 }}>Fecha</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Sugerencia</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {listaSugerenciasCliente
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((sugerencia) => (
                        <TableRow 
                          key={sugerencia.id}
                          sx={{ '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.02)' } }}
                        >
                        <TableCell>
                          {moment(sugerencia.fecgra).format("DD/MM/YYYY")}
                        </TableCell>
                          <TableCell>{sugerencia.sugerencia}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={listaSugerenciasCliente.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Filas por página:"
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
              />
            </Paper>
          ) : (
            <Box sx={{ textAlign: 'center', py: 3, color: 'text.secondary' }}>
              <LightbulbIcon sx={{ fontSize: 48, opacity: 0.3, mb: 1 }} />
              <Typography>No hay sugerencias registradas</Typography>
            </Box>
          )}
        </AccordionDetails>
      </Accordion>

      {/* Botones de Acción */}
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          size="large"
          startIcon={<ArrowBackIcon />}
          onClick={cerrarClientesPerfil}
          sx={{
            px: 4,
            borderColor: '#1976d2',
            color: '#1976d2',
            fontWeight: 600,
            '&:hover': {
              borderColor: '#1662aeff',
              bgcolor: 'rgba(102, 126, 234, 0.04)',
            },
          }}
        >
          Volver
        </Button>
        <Button
          variant="contained"
          size="large"
          startIcon={<SaveIcon />}
          onClick={ActualizarCliente}
          sx={{
            px: 4,
            bgcolor: '#1976d2',
            fontWeight: 600,
            boxShadow: '0 4px 14px 0 rgba(102, 126, 234, 0.39)',
            '&:hover': {
              bgcolor: '#1662aeff',
              boxShadow: '0 6px 20px rgba(102, 126, 234, 0.5)',
            },
          }}
        >
          Guardar Cambios
        </Button>
      </Box>
    </Container>
  );
};
export default withRouter(PerfilCliente);
